// Homepage (issue #12) — hero drží `screens/03-homepage.md` + `m03-homepage.md`,
// všechno pod ním `design_handoff_homepage/README.md` a prototyp
// `design/Homepage redesign.dc.html` (varianta 1a), který obě starší specifikace
// pro tuhle část NAHRAZUJE.
//
// Rytmus stránky = střídání celoplošných zón: bílá → tmavá (USP) → bílá
// (Nejoblíbenější) → červená (SLEVOAKCE) → světle šedá (Novinky + bento +
// „Mohlo by vás zajímat") → bílá (O nás, blog). Zóny jdou přes celou
// šířku viewportu, obsah uvnitř drží container (mixin `zone` v _homepage.scss).
//
// Enhancement nad fixním Shoptet DOM homepage (`body.type-index`). Co je v DOM,
// PŘEBÍRÁME i s daty (nevymýšlíme URL ani obsah):
//   • `.footer-banners`  → rozcestník kategorií (obrázek + název + odkaz z adminu)
//   • `.benefitBanner`   → USP pás (styluje _benefit-banner.scss)
//   • `.products-wrapper.product-slider-holder` × 4 → produktové řady; řada
//     s existujícím výpisem („Zobrazit vše") jede jako statická mřížka 4 karet
//     dle designu, řada bez něj zůstává scroll-snap carouselem se šipkami
//   • `h1.sr-only`       → viditelný H1 blok (řeší duplicitu h1 z handoffu)
//   • `.welcome`         → sekce „O nás" (text i foto prodejny jsou nativní)
// Vlastní markup dodáváme jen tam, kde v DOM není nic: hero carousel, rámec
// zóny SLEVOAKCE, bento bannery a „Rady a návody". Sekci hodnocení (dřív
// poslední blok homepage) staví od 2026-09-05 patička — reviews.js, je na
// každé stránce webu.
//
// Redaktorská data, která platforma nenese, čteme z admin bloků HTML kódů
// (`#bs-sale`) — bez nich se prvek NErenderuje, nikdy se neodhaduje. Hero nese obsah z designu (texty, ceny) — před go-live ověřit
// proti reálným datům, QA sweep issue #41.
//
// Pořadí sekcí na živém webu řídí admin → všechno se kotví na uzly, nikdy na
// `:nth-child`. Idempotentní (`data-bs-hp`), na mobilním UA renderu funguje
// stejně (Shoptet servíruje jiné HTML, ale homepage bloky má oba renderu stejné).

import { icon } from './icon.js';
import { MEDIA } from './instanceUrl.js';
import { money } from './money.js';
import { popular, categoryRank } from './searchApi.js';
import { getConfig, getIndexConfig } from './searchConfig.js';
import { cardNodes } from './productCardRender.js';
import { enhanceCards, observeCards } from './productCard.js';
import { page, withPages } from './pages.js';
import L from '../locale/cs/homepage.js';
import SHOP from '../../config/shop.js';
import { nextSundayMidnight, parseShopEnd } from './shopTime.js';
import { shippingPromo } from './shippingModel.js';
import { activeCampaign, campaignHeroMedia, heroWithCampaign, heroWithMedia, trackPromo } from './campaign.js';

const BP_MD = 768; // hranice „mobil" (_tokens.scss $bp-md)

// ---------------------------------------------------------------------------
// Obsah hero carouselu (03-homepage.md §1) je DATA shopu v jeho jazyce —
// manifest `homepage.hero` (src/config/bs.config.<shop>.mjs), tam i poznámky
// ke kartám. Karta míří na stránku z `pages` (`page`) nebo na vlastní `href`;
// stránku, kterou shop nemá, carousel vynechá. Štítek v rohu je vždy bílý.
// ---------------------------------------------------------------------------
// Akce na dopravu (#322): karta z `shipping.promo[].hero` (klíč = video) mluví
// po dobu akce o akci a stojí na pozici z manifestu. Karta 0 se nepřesouvá —
// její poster přednačítá hlavička HTML kódů (hero-preload). Výchozí hrající
// karta se drží podle videa, ne indexu, aby ji přesun nevyměnil. `hero.media`
// = vlastní vizuál karty po dobu akce (video, podklad, závoj, tmavý text).
const PROMO = shippingPromo();
// Kampaň (campaign.js): karta 0 mluví po dobu kampaně o deštníku, pozice zůstává;
// kampaň s vlastním vizuálem (Black Friday) ho kartě 0 dá od zapnutí přepínače
// (poster přednačítá hlavička); zóna akční nabídky a bento nesou název kampaně.
const CAMPAIGN = activeCampaign();

// Pořadí karet hera s akcí `promo` (výsledek shippingPromo, null = beze změny).
// Exportováno kvůli golden testu oken (tools/unit/shipping-promo.test.mjs).
export function heroWithPromo(cards, promo) {
  const h = promo && promo.hero;
  if (!h) return cards;
  const i = cards.findIndex(function (c) {
    return c.video === h.video;
  });
  if (i < 1) return cards;
  const card = Object.assign({}, cards[i], h.media || {}, { badge: h.badge, title: h.title, desc: h.desc, cta: h.cta });
  const rest = cards.filter(function (c, j) {
    return j !== i;
  });
  rest.splice(Math.max(1, Math.min(h.position, rest.length)), 0, card);
  return rest;
}

const HERO_BASE = SHOP.homepage.hero;
const HERO_DEFAULT_VIDEO = (HERO_BASE[Math.min(SHOP.homepage.heroDefault, HERO_BASE.length - 1)] || {}).video;
// text i vizuál kampaně podle okna (heroWithCampaign, campaignHeroMedia)
const HERO_TEXT = heroWithCampaign(HERO_BASE, CAMPAIGN);
const HERO_CAMPAIGN = HERO_TEXT !== HERO_BASE;
const HERO = heroWithPromo(heroWithMedia(HERO_TEXT, campaignHeroMedia(SHOP.campaigns)), PROMO)
  .map(function (card) {
    return Object.assign({}, card, {
      href: card.page ? page(card.page) : card.href,
      badge: card.badge ? { label: card.badge, tone: 'white', corner: true } : null,
    });
  })
  .filter(function (card) {
    return !!card.href;
  });
const HERO_DEFAULT = (function () {
  const byVideo = HERO.findIndex(function (c) {
    return c.video === HERO_DEFAULT_VIDEO;
  });
  return byVideo >= 0 ? byVideo : Math.min(SHOP.homepage.heroDefault, Math.max(HERO.length - 1, 0));
})();

const HERO_LABEL = L.hero.label;
const HERO_NEXT = L.hero.next;
const HERO_DOT = L.hero.dotPrefix;

// H1 blok (§2) — nativní `h1.sr-only` má jen název shopu, design chce claim.
// „s dopravou od X" = nejlevnější výdejní místo z ceníku manifestu.
// Po dobu akce na dopravu (#322) je nejlevnější výdejní místo akční cena.
const INTRO_SHIP_FROM = Math.min.apply(
  null,
  SHOP.shipping.bandPrices
    .map(function (b) {
      return b.box;
    })
    .concat(PROMO ? [PROMO.price] : []),
);
const INTRO = {
  title: L.intro.title,
  subBefore: L.intro.subBefore,
  subAccent: L.intro.subAccent,
  subAfter: L.intro.subAfter(INTRO_SHIP_FROM),
};

// Rozcestník kategorií (handoff homepage §1) — kruhy z admin bannerů
// `.footer-banners`. Design kreslí 8 kruhů, admin dodává 10; zbytek skryje CSS
// (třída, ne :nth-child).
const CATS_MAX = 8;

// Počet produktů pod názvem kategorie Shoptet v bannerech NEMÁ (handoff §1,
// otevřený bod). Bereme ho z textu banneru, když ho tam redaktor napíše —
// nikdy se neodhaduje v JS.
const CAT_COUNT_RE = L.catCountRe;

// „Zobrazit vše" u produktových řad. Cíl přidáváme jen tam, kde URL existuje
// (ověřeno proti navigaci shopu) — vymyšlený odkaz je horší než žádný.
// Řada s cílem jede v mřížkovém režimu designu (4 karty), řada bez něj zůstává
// carouselem se šipkami, jinak by se zbylé produkty staly nedosažitelnými
// (rozhodnutí Tomáše 2026-08-25).
const ROW_LINKS = withPages([
  { match: L.rowLinkSale, href: page('sale') },
  { match: L.rowLinkClearance, href: page('clearance') },
]);
// Podtitul řady (handoff §Nejoblíbenější produkty). Prototyp píše „Nejčastěji
// kupované za posledních 30 dní"; okno bestsellerového bloku Shoptet nikde
// nedokládá, číslo tedy netvrdíme. Podtitul navíc visí na TEXTU nadpisu, ne na
// pozici — pořadí bloků řídí admin a u „Novinek" by ta věta lhala.
const ROW_SUBS = [{ match: L.leadRowMatch, sub: L.row.leadSub }];
const ROW_ALL = L.row.all;
const ROW_PREV = L.row.prev;
const ROW_NEXT = L.row.next;
// Kolik karet ukazuje mřížkový režim (CSS zbytek schová; JS to jen ví kvůli
// rozhodnutí, jestli má řada ještě smysl posouvat šipkami).
const ROW_GRID_CARDS = 4;

// Sezónní bestsellery z indexu (F4, #243 — rozhodnutí Tomáše 2026-09-13): řada
// „Nejoblíbenější" se po načtení naplní z `/popular?order=seasonal` (sezónní skóre:
// tržba 30 dní s pamětí 90 dní očištěná o sezónu, search/indexer/season.mjs),
// rozcestník kruhů se přeskládá dle `/category-rank`.
// Bez indexu (LB, velkoobchod, výpadek, jiná `strategy`) zůstává nativní obsah
// z adminu — tichá degradace, nikdy prázdno. Layout se nemění, jen obsah.
const LEAD_ROW_MATCH = L.leadRowMatch;
const LEAD_ROW_LIMIT = 12;
const LEAD_ROW_MIN = 4;
const NATIVE_HIDDEN = 'bs-prow__native-hidden';

// Řada, kolem které se staví červená zóna SLEVOAKCE (handoff §3). Klíčujeme na
// text nadpisu z adminu, ne na pořadí — pořadí bloků na HP řídí redaktor.
const SALE_MATCH = L.saleMatch;
const SALE = {
  eyebrow: L.sale.eyebrow,
  href: page('sale'),
  cdLabel: L.sale.cdLabel,
  cdUnits: L.sale.cdUnits,
  // Počet zlevněných produktů homepage v DOM nemá — bez čísla z admin bloku
  // jde neutrální znění, odhad by lhal.
  ctaWithCount: L.sale.ctaWithCount,
  ctaPlain: L.sale.ctaPlain,
};

// Admin bloky (HTML kódy) — stejný vzor jako `#bs-cat-photos` u výpisu:
// redaktor je plní v adminu, kód se bez nich musí korektně degradovat.
const SALE_BLOCK = 'bs-sale';

// Bento bannery (§6). Fotky = podklady z designu nahrané v adminu. `imageMobile`
// = druhý ořez pro jeden sloupec (≤ 768 px), kde karta není pás 3:1, ale 2:1.
const BENTO = [
  {
    modifier: 'b2b',
    href: page('b2b'),
    image: 'hf_20260714_182902_89d5c534-4998-48cf-aefa-6a7c9ca267f1.webp',
    eyebrow: L.bento.b2b.eyebrow,
    title: L.bento.b2b.title,
    text: L.bento.b2b.text,
    cta: L.bento.b2b.cta,
  },
  {
    modifier: 'sale',
    href: page('sale'),
    // vizuál E Říjnového výprodeje (2026-10-07, ops/hero/2026-10-vyprodej/zaznam.md):
    // sada BX187 ve studiu, desktop pás 3:1, mobil 16:9
    image: 'codex_20261007_vyprodej_e-bento.webp',
    imageMobile: 'codex_20261007_vyprodej_e-bento-m.webp',
    title: L.bento.sale.title,
    text: L.bento.sale.text,
    cta: L.bento.sale.cta,
    glyph: 'percent',
  },
];

// Rady a návody (§9). Homepage nemá blokový výpis blogu (admin ho na HP nemá),
// takže sekci skládáme z reálných článků shopu — manifest `homepage.articles`
// (URL, titulky, fotky karet a rubrika jako meta řádek). Prázdné = sekce není.
const ARTICLES_TITLE = L.articles.title;
const ARTICLES_ALL = { label: L.articles.all, href: page('blog', 'rady-a-tipy/') };
const ARTICLES = SHOP.homepage.articles;

// O nás (§10) — nadpis a doplňky z designu, text a foto zůstávají nativní.
const ABOUT = {
  eyebrow: L.about.eyebrow,
  title: L.about.title,
  cta: { label: L.about.ctaLabel, href: page('store') },
  badgeTitle: L.about.badgeTitle,
  badgeText: SHOP.homepage.aboutBadge,
};


// ---------------------------------------------------------------------------
// Helpery
// ---------------------------------------------------------------------------

function node(tag, className, text) {
  const n = document.createElement(tag);
  if (className) n.className = className;
  if (text != null) n.textContent = text;
  return n;
}

function link(href, className, text) {
  const a = node('a', className, text);
  a.href = href;
  return a;
}

// Data z admin bloku HTML kódů (`<span id="bs-…" data-bs-klic="…">`). Vzor je
// stejný jako `#bs-cat-photos` u výpisu — blok nemusí existovat.
function adminData(id) {
  const el = document.getElementById(id);
  return el ? el.dataset : null;
}

// `window.innerWidth` vynucuje synchronní layout a `isMobile()` se při bootu volá
// pro každou ze 7 hero karet i pětkrát v `sync()` — proložené zápisy do DOM z toho
// dělaly 1,1 s self-time při CPU 4× (profil 2026-09-11, F1). MediaQueryList vyhodnotí
// prohlížeč bez reflow a sám ho drží aktuální při resize.
// ⚠ Vyhodnotit lazy, ne na modulové úrovni — devcheck importuje modul do Node
// kvůli unit testům a `window` tam neexistuje (regrese chycená 2026-09-11).
let mqMobile;
const isMobile = () => {
  if (mqMobile === undefined) {
    mqMobile = window.matchMedia ? window.matchMedia('(max-width: ' + BP_MD + 'px)') : null;
  }
  return mqMobile ? mqMobile.matches : window.innerWidth <= BP_MD;
};
const reducedMotion = () =>
  window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function scrollTrack(track, left) {
  if (track.scrollTo) track.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' });
  else track.scrollLeft = left;
}

// ---------------------------------------------------------------------------
// 1. Hero carousel
// ---------------------------------------------------------------------------

function heroCard(data, index) {
  const card = node('article', 'bs-hero__card bs-hero__card--' + data.tone);
  if (data.ink) card.classList.add('bs-hero__card--ink');
  // Karty bez ceny nesou claim — mockup jim dává větší titulek (§1).
  if (!data.price) card.classList.add('bs-hero__card--lead');

  const video = document.createElement('video');
  video.className = 'bs-hero__video';
  // `src` se dosazuje až v playVideo() (po `load`, jen kartě, která má hrát):
  // 7 klipů s preload=metadata + PNG postery dřív stahovaly 17–25 MB na každé
  // otevření homepage (měření 2026-09-09, fáze 0 plánu rychlosti). Do té doby
  // kartu drží WebP poster z tools/media/build-hero.mjs (má ho každá karta).
  video.dataset.bsVideo = data.video;
  video.poster = MEDIA + data.video + '-poster.webp';
  video.muted = true;
  video.defaultMuted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = 'none';
  video.setAttribute('muted', '');
  video.setAttribute('loop', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('aria-hidden', 'true');
  video.setAttribute('tabindex', '-1');
  card.appendChild(video);

  if (data.overlay && data.overlay !== 'none') {
    card.appendChild(node('span', 'bs-hero__veil bs-hero__veil--' + data.overlay));
  }

  if (data.badge) {
    const badge = node(
      'span',
      'bs-hero__badge bs-hero__badge--' + data.badge.tone + (data.badge.corner ? ' bs-hero__badge--corner' : ''),
      data.badge.label
    );
    card.appendChild(badge);
  }

  const body = node('div', 'bs-hero__body');
  body.appendChild(node('h2', 'bs-hero__title', data.title));
  if (data.desc) body.appendChild(node('p', 'bs-hero__desc', data.desc));
  if (data.price) {
    const row = node('div', 'bs-hero__price');
    row.appendChild(node('span', 'bs-hero__price-now', money(data.price)));
    if (data.priceOld) row.appendChild(node('s', 'bs-hero__price-old', money(data.priceOld)));
    if (data.note) row.appendChild(node('span', 'bs-hero__price-note', data.note));
    body.appendChild(row);
  }
  const cta = link(data.href, 'bs-btn bs-hero__cta', data.cta);
  if (data.ctaTone === 'white') cta.classList.add('bs-btn--white');
  body.appendChild(cta);
  card.appendChild(body);

  // Celá karta je proklik, ne jen tlačítko (review Tomáše 2026-09-09):
  // neviditelný odkaz přes celou plochu POD tělem karty (body má z-index 2),
  // tělo nechává události propadnout (`pointer-events: none`), jen CTA je
  // zase klikací — čtečka vidí jeden odkaz s textem CTA, overlay je pro ni
  // skrytý. Swipe zůstává: track je nativní scroll-snap, drag na odkazu
  // klik nevystřelí.
  const cover = link(data.href, 'bs-hero__link');
  cover.setAttribute('aria-hidden', 'true');
  cover.setAttribute('tabindex', '-1');
  card.insertBefore(cover, body);

  card.dataset.bsHeroIndex = String(index);
  return card;
}

// Média hero se „odjišťují" až po `load` (nebo nejpozději po HERO_ARM_MS na pomalé
// síti, kde `load` čeká na zbytek stránky) — do té doby nesoutěží s CSS, bundlem
// a fotkami o šířku pásma a poster stojí od prvního paintu.
const HERO_ARM_MS = 4000;
let heroMediaArmed = false;

// desktop 800 px / mobil 640 px varianta klipu (build-hero.mjs), volba jednou při načtení
function videoSrc(video) {
  return MEDIA + video.dataset.bsVideo + (isMobile() ? '-m' : '-d') + '.mp4';
}

function playVideo(video) {
  if (!video || !heroMediaArmed) return;
  if (!video.getAttribute('src')) video.src = videoSrc(video); // první přehrání = první stažení
  video.muted = true;
  const p = video.play();
  if (p && p.catch) p.catch(function () {});
}

function pauseVideo(video, rewind) {
  if (video && !video.getAttribute('src')) return; // nikdy nestažené — není co pauzovat
  if (!video || video.paused) {
    if (video && rewind) video.currentTime = 0;
    return;
  }
  video.pause();
  if (rewind) video.currentTime = 0;
}

function buildHero(content, anchor) {
  if (!HERO.length) return; // shop bez obsahu hera (manifest homepage.hero)
  const section = node('section', 'bs-hero');
  section.setAttribute('aria-label', HERO_LABEL);

  const track = node('div', 'bs-hero__track');
  HERO.forEach(function (data, i) {
    track.appendChild(heroCard(data, i));
  });
  section.appendChild(track);

  const arrow = node('button', 'bs-hero__arrow');
  arrow.type = 'button';
  arrow.setAttribute('aria-label', HERO_NEXT);
  arrow.appendChild(icon('arrow-right'));
  section.appendChild(arrow);

  const dots = node('div', 'bs-hero__dots');
  section.appendChild(dots);

  content.insertBefore(section, anchor);
  // karta 0 mluví po dobu kampaně o deštníku (heroWithCampaign, klíč = video karty)
  if (HERO_CAMPAIGN && HERO[0] && HERO[0].title === CAMPAIGN.hero.title) trackPromo(track.children[0], CAMPAIGN, 'hero');
  wireHero(section, track, arrow, dots);
  return section;
}

function wireHero(section, track, arrow, dots) {
  const cards = Array.prototype.slice.call(track.children);
  const videos = cards.map(function (c) {
    return c.querySelector('video');
  });
  let buttons = [];
  let active = 0;
  let hovered = -1;

  function step() {
    if (cards.length < 2) return cards.length ? cards[0].offsetWidth : 1;
    return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left || 1;
  }

  function maxScroll() {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function pages() {
    // mobil = tečka na kartu (m03), desktop = 2 stránky pásu (03-homepage.md §1)
    return isMobile() ? cards.length : 2;
  }

  function offsetOf(i) {
    return isMobile() ? Math.min(i * step(), maxScroll()) : i ? maxScroll() : 0;
  }

  function indexFromScroll() {
    const max = maxScroll();
    if (isMobile()) return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step())));
    return max > 0 && track.scrollLeft > max / 2 ? 1 : 0;
  }

  function renderDots() {
    const count = pages();
    if (buttons.length === count) return;
    dots.textContent = '';
    buttons = [];
    for (let i = 0; i < count; i += 1) {
      const dot = node('button', 'bs-hero__dot');
      dot.type = 'button';
      dot.setAttribute('aria-label', HERO_DOT + (i + 1));
      dot.addEventListener('click', function () {
        scrollTrack(track, offsetOf(i));
      });
      dots.appendChild(dot);
      buttons.push(dot);
    }
  }

  function playback() {
    if (reducedMotion()) {
      videos.forEach(function (v) {
        pauseVideo(v, false);
      });
      return;
    }
    if (isMobile()) {
      // mobil: hraje jen karta, na které uživatel právě je (data i baterie)
      videos.forEach(function (v, i) {
        if (i === active) playVideo(v);
        else pauseVideo(v, false);
      });
      return;
    }
    videos.forEach(function (v, i) {
      if (i === (hovered >= 0 ? hovered : HERO_DEFAULT)) playVideo(v);
      else pauseVideo(v, i !== HERO_DEFAULT);
    });
  }

  function sync() {
    renderDots();
    active = indexFromScroll();
    buttons.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
    arrow.classList.toggle('is-back', !isMobile() && active === 1);
    playback();
  }

  // --- autoplay (mobil, zadání Tomáše 2026-08-31): karta se posune sama po
  // 4 s. Končí PRVNÍ interakcí uživatele s carouselem (dotyk na track, tečka,
  // šipka) — autoplay nemá bojovat s prstem. Tik se přeskočí se skrytou
  // záložkou a mimo viewport; reduced motion autoplay vůbec nespustí.
  const AUTOPLAY_MS = 4000;
  let autoTimer = 0;
  let autoStopped = false;
  let heroInView = true;

  function stopAutoplay() {
    autoStopped = true;
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = 0;
    }
  }

  function autoplaySync() {
    if (autoStopped || reducedMotion()) return;
    if (!isMobile()) {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = 0;
      }
      return;
    }
    if (autoTimer) return;
    autoTimer = setInterval(function () {
      if (document.hidden || !heroInView) return;
      const next = active + 1 >= pages() ? 0 : active + 1;
      scrollTrack(track, offsetOf(next));
    }, AUTOPLAY_MS);
  }

  track.addEventListener('touchstart', stopAutoplay, { passive: true });
  track.addEventListener('pointerdown', stopAutoplay, { passive: true });
  dots.addEventListener('click', stopAutoplay);

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      heroInView = entries[0].isIntersecting;
    }).observe(section);
  }

  let raf = 0;
  track.addEventListener(
    'scroll',
    function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        sync();
      });
    },
    { passive: true }
  );

  arrow.addEventListener('click', function () {
    stopAutoplay();
    const count = pages();
    const next = active + 1 >= count ? 0 : active + 1;
    scrollTrack(track, offsetOf(next));
  });

  cards.forEach(function (card, i) {
    card.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      hovered = i;
      playback();
    });
    card.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      hovered = -1;
      playback();
    });
  });

  let resizeTimer = 0;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      sync();
      autoplaySync(); // mobil ↔ desktop: interval jede jen na mobilu
    }, 150);
  });

  // ⚠ `sync()` čte geometrii pásu (`maxScroll` → scrollWidth/clientWidth) — hned po
  // vložení hero do DOM to vynucovalo layout (562 ms self-time při CPU 4×, profil
  // 2026-09-11, F1). rAF běží po zbytku boot zápisů, ale pořád PŘED paintem, takže
  // tečky i stav šipky jsou na místě už při prvním vykreslení.
  requestAnimationFrame(function () {
    sync();
    autoplaySync();
  });

  // odjištění médií: `load`, nebo strop HERO_ARM_MS — co přijde dřív; pak se
  // přes playback() stáhne a rozběhne jen karta, která má hrát
  let armed = false;
  function armMedia() {
    if (armed) return;
    armed = true;
    heroMediaArmed = true;
    playback();
  }
  if (document.readyState === 'complete') setTimeout(armMedia, 0);
  else window.addEventListener('load', armMedia, { once: true });
  setTimeout(armMedia, HERO_ARM_MS);
}

// ---------------------------------------------------------------------------
// 2. H1 blok — přebírá nativní `h1.sr-only` (žádná druhá h1 na stránce)
// ---------------------------------------------------------------------------

function buildIntro(content) {
  const h1 = content.querySelector('h1');
  const box = node('div', 'bs-hp-intro');

  const title = h1 || node('h1');
  title.classList.remove('sr-only');
  title.classList.add('bs-hp-intro__title');
  title.textContent = INTRO.title;

  const sub = node('p', 'bs-hp-intro__sub');
  sub.appendChild(document.createTextNode(INTRO.subBefore));
  sub.appendChild(node('span', 'bs-hp-intro__accent', INTRO.subAccent));
  sub.appendChild(document.createTextNode(INTRO.subAfter));

  if (h1 && h1.parentNode) h1.parentNode.insertBefore(box, h1);
  box.appendChild(title);
  box.appendChild(sub);
  return box;
}

// ---------------------------------------------------------------------------
// 3. Rozcestník kategorií — admin bannery `.footer-banners`
// ---------------------------------------------------------------------------

// Fotku obaluje kruh — nativní markup je `a > img`, kolečko v DOM není.
function ringWrap(img) {
  if (img.parentNode && img.parentNode.classList.contains('bs-hp-cat__ring')) return;
  const ring = node('span', 'bs-hp-cat__ring');
  img.parentNode.insertBefore(ring, img);
  ring.appendChild(img);
  // Rozměry z adminu (162×176 apod.) by přebily CSS 86×86.
  img.removeAttribute('width');
  img.removeAttribute('height');
}

// „34 produktů" na konci textu banneru odřízneme do vlastního řádku. Když ho
// tam redaktor nenapsal, řádek prostě nevznikne (handoff §1, otevřený bod).
function splitCount(title) {
  const raw = (title.textContent || '').replace(/\s+/g, ' ').trim();
  const m = raw.match(CAT_COUNT_RE);
  if (!m) return null;
  title.textContent = raw.slice(0, m.index).trim();
  return node('span', 'bs-hp-cat__count', m[1].replace(/\s/g, ' ').trim() + ' ' + m[2]);
}

function buildCats(content) {
  const strip = content.querySelector('.footer-banners');
  if (!strip) return null;
  strip.classList.add('bs-hp-cats');

  const items = strip.querySelectorAll('.footer-banner');
  items.forEach(function (item, i) {
    item.classList.add('bs-hp-cat');
    if (i >= CATS_MAX) item.classList.add('bs-hp-cat--rest');
    const a = item.querySelector('a');
    if (a) a.classList.add('bs-hp-cat__link');
    const img = item.querySelector('img');
    if (img) {
      img.classList.add('bs-hp-cat__img');
      ringWrap(img);
    }
    const title = item.querySelector('.extended-banner-title');
    if (title) {
      title.classList.add('bs-hp-cat__text');
      const count = splitCount(title);
      if (count) title.parentNode.appendChild(count);
    }
  });
  return strip;
}

// ---------------------------------------------------------------------------
// 4. Produktové řady — nativní slider → CSS scroll-snap carousel
// ---------------------------------------------------------------------------

function rowLink(label) {
  for (const item of ROW_LINKS) {
    if (item.match.test(label)) return item.href;
  }
  return null;
}

function rowSub(label) {
  for (const item of ROW_SUBS) {
    if (item.match.test(label)) return item.sub;
  }
  return null;
}

// Šipky carouselu. Design je nemá (řada je statická mřížka 4 karet + odkaz do
// výpisu), takže je dodáváme JEN řadě bez cíle „Zobrazit vše" a s víc než
// čtyřmi produkty — jinak by byl zbytek řady z homepage nedosažitelný.
function addRowNav(head, row) {
  [
    { dir: -1, label: ROW_PREV, glyph: 'arrow-left', cls: 'bs-prow__nav--prev' },
    { dir: 1, label: ROW_NEXT, glyph: 'arrow-right', cls: 'bs-prow__nav--next' },
  ].forEach(function (spec) {
    const btn = node('button', 'bs-btn bs-btn--circle bs-prow__nav ' + spec.cls);
    btn.type = 'button';
    btn.setAttribute('aria-label', spec.label);
    btn.appendChild(icon(spec.glyph));
    btn.addEventListener('click', function () {
      const track = row.track;
      if (track) scrollTrack(track, track.scrollLeft + spec.dir * Math.max(240, track.clientWidth * 0.8));
    });
    head.appendChild(btn);
  });
}

// Hlavička řady dle prototypu: nadpis · podtitul · rozpěra · „Zobrazit vše".
// `opts.sub` = podtitul, `opts.lead` = bílá zóna (rytmus 44/48),
// `opts.gap` = druhá řada uvnitř šedé zóny (odsazení 36 od bento bannerů).
function buildRowHead(row, opts) {
  const head = row.head;
  if (!head) return;
  const o = opts || {};

  head.classList.add('bs-sechead', 'bs-prow__head');
  if (o.lead) head.classList.add('bs-prow__head--lead');
  if (o.gap) head.classList.add('bs-prow__head--gap');
  head.textContent = '';

  head.appendChild(node('h2', 'bs-sechead__title', row.label));
  if (o.sub) head.appendChild(node('span', 'bs-prow__sub', o.sub));
  head.appendChild(node('span', 'bs-sechead__spacer'));

  if (row.href) head.appendChild(link(row.href, 'bs-btn bs-btn--ghost bs-prow__all', ROW_ALL));
  else if (row.cards > ROW_GRID_CARDS) addRowNav(head, row);
}

// Nativní drag slider vypínáme a mechaniku nahrazujeme CSS scroll-snapem.
// POZOR: serverové HTML má jen `.products-wrapper > #products-N.products.product-slider`
// — třídy `product-slider-holder`, `has-navigation`, obal `.products-block`,
// stránkování i inline šířky dodává default JS AŽ za běhu (fixtures ho mají
// zachycený). Pořadí boot vs. default JS není zaručené, proto row sleduje obal
// MutationObserverem a přepne se na `.products-block`, kdyby vznikl později.
function enhanceRow(holder) {
  const slider = holder.querySelector('.products');
  const row = { holder: holder, track: null, head: null, label: '', href: null, cards: 0 };

  row.cards = holder.querySelectorAll('.p[data-micro="product"]').length;
  holder.classList.add('bs-prow');
  holder.classList.remove('has-navigation');
  if (slider) {
    slider.classList.add('bs-prow__viewport');
    slider.classList.remove('product-slider'); // hook nativního slideru
  }

  function cleanup() {
    holder.removeAttribute('style'); // `overflow: hidden` z default JS
    if (slider) slider.removeAttribute('style');
    holder.querySelectorAll('.product-slider-pagination, .product-slider-navigation').forEach(function (n) {
      n.remove();
    });
  }

  function retarget() {
    const track = holder.querySelector('.products-block') || slider;
    if (!track || track === row.track) return;
    if (row.track) row.track.classList.remove('bs-prow__track');
    row.track = track;
    track.classList.add('bs-prow__track');
    track.removeAttribute('style');
  }

  cleanup();
  retarget();

  // Reagovat jen na vložení obalu slideru nebo jeho ovládání (review B4-05):
  // dekorace karet a lazy obrázky mění podstrom řady po celý život stránky
  // a plný průchod cleanup() nad každou dávkou je zbytečná práce.
  const RELEVANT = '.products-block, .product-slider-pagination, .product-slider-navigation';
  new MutationObserver(function (records) {
    const hit = records.some(function (r) {
      return Array.prototype.some.call(r.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches(RELEVANT) || !!n.querySelector(RELEVANT));
      });
    });
    if (!hit) return;
    cleanup();
    retarget();
  }).observe(holder, { childList: true, subtree: true });

  const title = holder.previousElementSibling;
  if (title && title.classList.contains('homepage-group-title')) {
    row.head = title;
    row.label = (title.textContent || '').replace(/\s+/g, ' ').trim();
  }
  row.href = rowLink(row.label);
  // Mřížkový režim designu jen tam, kde na zbytek řady vede odkaz.
  if (row.href) holder.classList.add('bs-prow--grid');
  return row;
}

function enhanceRows(content) {
  const rows = [];
  content.querySelectorAll('.products-wrapper').forEach(function (holder) {
    if (!holder.querySelector('.p[data-micro="product"]')) return;
    rows.push(enhanceRow(holder));
  });
  return rows;
}

// Řada „Nejoblíbenější" z indexu: karty z API nahradí nativní karty adminu (ty
// zůstávají v DOM skryté — default JS slideru i MutationObserver řady s nimi počítají).
function fillLeadRowFromIndex(row, items) {
  if (!row || !LEAD_ROW_MATCH.test(row.label) || !row.track) return false;
  if (!items || items.length < LEAD_ROW_MIN) return false;
  const track = row.track;
  track.querySelectorAll(':scope > .product').forEach(function (n) {
    n.classList.add(NATIVE_HIDDEN);
  });
  track.appendChild(cardNodes(items));
  enhanceCards(track);
  observeCards(track);
  row.cards = items.length;
  row.holder.classList.add('bs-prow--index');
  return true;
}

// Rozcestník kategorií podle skóre z indexu: banner se páruje na kategorii přes
// cestu URL; bannery bez shody jdou na konec v adminovém pořadí.
async function orderCatsByRank(strip) {
  if (!strip) return false;
  const res = await categoryRank();
  if (!res || res.strategy !== 'revenue_seasonal' || !res.items || !res.items.length) return false;
  const score = {};
  res.items.forEach(function (it) {
    const p = pathOf(it.url);
    if (p && score[p] === undefined) score[p] = it.score;
  });
  const items = Array.prototype.slice.call(strip.querySelectorAll('.bs-hp-cat'));
  const ranked = items.map(function (item, i) {
    const a = item.querySelector('a');
    const p = a ? pathOf(a.getAttribute('href')) : null;
    return { item: item, i: i, score: p && score[p] !== undefined ? score[p] : -1 };
  });
  if (!ranked.some(function (r) { return r.score >= 0; })) return false;
  ranked.sort(function (a, b) { return (b.score - a.score) || (a.i - b.i); });
  ranked.forEach(function (r, i) {
    r.item.classList.toggle('bs-hp-cat--rest', i >= CATS_MAX);
    strip.appendChild(r.item);
  });
  strip.classList.add('bs-hp-cats--ranked');
  return true;
}

function pathOf(href) {
  if (!href) return null;
  try {
    return new URL(href, location.href).pathname.replace(/\/+$/, '') || '/';
  } catch (e) {
    return null;
  }
}

// `/popular?order=seasonal` je zároveň sonda verze API: starý server `order`
// ignoruje a vrátí `strategy: revenue_90d` → nic se nemění a `/category-rank`
// (na starém API 404) se vůbec nevolá — smoke matice bere každý 404 jako FAIL.
//
// Velkoobchod (VO ceník 13/16/19, 2026-09-14): `/popular` vrací karty v jeho
// ceně (`pl`). Jiný ceník, který index nenese (`getConfig()` null), drží řadu
// z adminu; rozcestník cenu nenese a řadí se i jemu. Starý API / generace bez
// VO polí vrací VO dotazu 400 → řada z adminu, rozcestník se řadí dál (bez
// sondy — smoke jede jako nepřihlášený).
async function enhanceFromIndex(row, strip) {
  const cfg = getConfig();
  if (!cfg) return getIndexConfig() ? orderCatsByRank(strip) : false;
  const res = await popular(LEAD_ROW_LIMIT, 'seasonal');
  if (!res && cfg.priceListId !== 1) return orderCatsByRank(strip);
  if (!res || res.strategy !== 'revenue_seasonal') return false;
  fillLeadRowFromIndex(row, res.items);
  await orderCatsByRank(strip);
  return true;
}

// Po `load` a v idle — stránka se kreslí z nativního HTML, index jen doplní
// obsah (perf F1: žádné čekání na síť v bootu, žádný forced layout).
function scheduleIndexEnhancements(row, strip) {
  const run = function () {
    const idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
    idle(function () {
      enhanceFromIndex(row, strip).catch(function () {});
    });
  };
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
}

// Řadu i s jejím nadpisem přesuneme do zóny (pořadí head → holder).
function moveRow(parent, row) {
  if (row.head) parent.appendChild(row.head);
  parent.appendChild(row.holder);
}

// ---------------------------------------------------------------------------
// 4b. Zóna SLEVOAKCE (handoff §3) — celoplošná červená zóna kolem řady
// „Slevoakce". Počet zlevněných produktů plní redaktor v admin bloku `#bs-sale`;
// bez něj jede CTA v neutrálním znění.
//
// Odpočet běží v týdenním cyklu: vždy do NEJBLIŽŠÍ NEDĚLNÍ PŮLNOCI a po jejím
// uplynutí se sám překlopí na další neděli — akce je věčně živá a redaktor do ní
// nesahá. `data-bs-end` je od té doby jen *override* pro jednorázovou kampaň
// s pevným koncem: dokud platí, odpočítává se k němu, a jakmile doběhne, odpočet
// zmizí (kampaň skutečně skončila) místo překlopení.
// ---------------------------------------------------------------------------

// Čas obchodu (pásmo shopu, týdenní neděle, pevný konec kampaně) počítá
// shopTime.js — sdílí ho okna akcí (#322). Re-export kvůli harnessům
// (tools/devcheck/homepage.mjs, tools/unit/sale-end.test.mjs).
export { nextSundayMidnight, parseShopEnd };

function buildCountdown(endRaw) {
  // Pevné datum z adminu = jednorázová kampaň; už doběhlá se nevykresluje.
  const fixed = endRaw ? parseShopEnd(endRaw) : NaN;
  const hasFixed = !!endRaw && !isNaN(fixed);
  if (hasFixed && fixed <= Date.now()) return null;
  let end = hasFixed ? fixed : nextSundayMidnight(Date.now());

  const box = node('div', 'bs-sale__cd');
  box.appendChild(node('span', 'bs-sale__cd-label', SALE.cdLabel));

  const nums = SALE.cdUnits.map(function (unit) {
    const cell = node('span', 'bs-sale__cd-box');
    const num = node('span', 'bs-sale__cd-num', '0');
    cell.appendChild(num);
    cell.appendChild(node('span', 'bs-sale__cd-unit', unit));
    box.appendChild(cell);
    return num;
  });

  const pad = (n) => String(n).padStart(2, '0');
  function tick() {
    let left = Math.floor((end - Date.now()) / 1000);
    if (left <= 0) {
      // Jednorázová kampaň doběhla: odpočet zmizí, zóna zůstane (handoff §3).
      if (hasFixed) {
        clearInterval(timer);
        box.remove();
        return;
      }
      // Týdenní cyklus: překlopíme se na další neděli a odpočítáváme dál.
      end = nextSundayMidnight(Date.now());
      left = Math.max(0, Math.floor((end - Date.now()) / 1000));
    }
    nums[0].textContent = String(Math.floor(left / 86400));
    nums[1].textContent = pad(Math.floor(left / 3600) % 24);
    nums[2].textContent = pad(Math.floor(left / 60) % 60);
    nums[3].textContent = pad(left % 60);
  }
  tick();
  // Zóna odstraněná z DOM = konec tikání (review B4-05); první tik proběhl
  // ještě před vložením boxu, proto kontrola až v intervalu.
  const timer = setInterval(function () {
    if (!box.isConnected) {
      clearInterval(timer);
      return;
    }
    tick();
  }, 1000);
  return box;
}

function buildSaleZone(content, row) {
  const cfg = adminData(SALE_BLOCK) || {};
  // Po dobu kampaně zóna nese deštník: nadpis kampaně místo názvu řady z adminu,
  // claim výprodeje v eyebrow, bez odpočtu (výprodej nekončí datem, po kterém
  // by cena skončila — týdenní cyklus by lhal) a CTA bez čísla.
  const campaign = CAMPAIGN;
  const anchor = row.head || row.holder;
  const section = node('section', 'bs-sale');
  if (campaign ? campaign.tone === 'ink' : cfg.bsTone === 'ink') section.classList.add('bs-sale--ink');
  if (campaign) section.dataset.bsCampaign = campaign.id;
  content.insertBefore(section, anchor);

  const inner = node('div', 'bs-sale__in');
  section.appendChild(inner);
  inner.appendChild(icon('percent', 'bs-sale__glyph'));

  const head = node('div', 'bs-sale__head');
  const intro = node('div', 'bs-sale__intro');
  intro.appendChild(node('span', 'bs-sale__eyebrow', campaign ? campaign.t.zoneEyebrow(campaign.claim) : SALE.eyebrow));

  // Nativní nadpis řady se stává titulem zóny — text zůstává z adminu a na
  // stránce nevzniká druhý nadpis.
  const title = row.head || node('h2');
  title.className = 'bs-sale__title';
  title.textContent = campaign ? campaign.name : row.label;
  intro.appendChild(title);
  head.appendChild(intro);
  head.appendChild(node('span', 'bs-sale__spacer'));

  const cd = campaign ? null : buildCountdown(cfg.bsEnd);
  if (cd) head.appendChild(cd);
  inner.appendChild(head);
  inner.appendChild(row.holder);

  const foot = node('div', 'bs-sale__foot');
  let label = cfg.bsCount ? SALE.ctaWithCount(cfg.bsCount) : SALE.ctaPlain;
  if (campaign) label = campaign.t.zoneCta;
  const cta = link(row.href || SALE.href, 'bs-btn bs-sale__cta', label);
  cta.appendChild(icon('arrow-right'));
  foot.appendChild(cta);
  inner.appendChild(foot);
  // proklik jen z CTA — karty zboží v zóně měří nativní select_item
  if (campaign) trackPromo(section, campaign, 'sale_zone', { clickSel: '.bs-sale__cta' });
  return section;
}

// ---------------------------------------------------------------------------
// 4c. Světle šedá zóna (handoff §4 + §4b) — Novinky, bento bannery a řada
// „Mohlo by vás zajímat" v jednom pásu.
// ---------------------------------------------------------------------------

function buildGreyZone(content, rows, bento) {
  if (!rows.length) return null;
  const section = node('section', 'bs-hp-grey');
  // Kotva nemusí být přímé dítě obsahu: SK homepage balí řady do dalšího obalu
  // (S4 #400), takže se zóna vkládá k rodiči kotvy, ne do `content`.
  const anchor = rows[0].head || rows[0].holder;
  (anchor.parentNode || content).insertBefore(section, anchor);

  moveRow(section, rows[0]);
  buildRowHead(rows[0]);
  section.appendChild(bento);
  rows.slice(1).forEach(function (row) {
    moveRow(section, row);
    buildRowHead(row, { gap: true });
  });
  return section;
}

// ---------------------------------------------------------------------------
// 5. Bento bannery
// ---------------------------------------------------------------------------

// Bento akční nabídky po dobu kampaně: nadpis kampaně a claim výprodeje místo
// obecného „Slevy až −40 %" (číslo neověřené daty, plán kampaní 6. 10.).
function bentoData(data) {
  if (data.modifier !== 'sale' || !CAMPAIGN) return data;
  const t = CAMPAIGN.t;
  const m = CAMPAIGN.media;
  const look = m ? { image: m.bento, imageMobile: m.bentoMobile } : {};
  if (CAMPAIGN.tone === 'ink') look.tone = 'ink';
  return Object.assign({}, data, look, { href: CAMPAIGN.href, title: CAMPAIGN.name, text: t.bentoText(CAMPAIGN.claim), cta: t.bentoCta });
}

function buildBento() {
  const section = node('section', 'bs-bento');
  BENTO.map(bentoData).forEach(function (data) {
    const item = link(data.href, 'bs-bento__item bs-bento__item--' + data.modifier + (data.tone ? ' bs-bento__item--' + data.tone : ''));
    const img = document.createElement('img');
    img.className = 'bs-bento__bg';
    img.src = MEDIA + data.image;
    img.alt = '';
    img.loading = 'lazy';
    if (data.imageMobile) {
      // hranice = $bp-md jako u promo karty výpisu; obal má `display: contents`
      const pic = document.createElement('picture');
      const source = document.createElement('source');
      source.media = '(max-width: ' + BP_MD + 'px)';
      source.srcset = MEDIA + data.imageMobile;
      pic.appendChild(source);
      pic.appendChild(img);
      item.appendChild(pic);
    } else {
      item.appendChild(img);
    }
    if (data.modifier === 'b2b') item.appendChild(node('span', 'bs-bento__veil'));
    if (data.glyph) {
      const glyph = icon(data.glyph, 'bs-bento__glyph');
      item.appendChild(glyph);
    }
    if (data.eyebrow) item.appendChild(node('span', 'bs-bento__eyebrow', data.eyebrow));
    item.appendChild(node('span', 'bs-bento__title', data.title));
    item.appendChild(node('span', 'bs-bento__text', data.text));
    item.appendChild(node('span', 'bs-btn bs-btn--sm bs-bento__cta', data.cta));
    section.appendChild(item);
    if (data.modifier === 'sale' && CAMPAIGN) trackPromo(item, CAMPAIGN, 'bento');
  });
  return section;
}

// ---------------------------------------------------------------------------
// 6. Rady a návody
// ---------------------------------------------------------------------------

function buildArticles() {
  if (!ARTICLES.length) return null; // shop bez článků (manifest homepage.articles)
  const section = node('section', 'bs-hp-arts');

  const head = node('div', 'bs-sechead bs-prow__head');
  head.appendChild(node('h2', 'bs-sechead__title', ARTICLES_TITLE));
  head.appendChild(node('span', 'bs-sechead__spacer'));
  head.appendChild(link(ARTICLES_ALL.href, 'bs-btn bs-btn--ghost bs-prow__all', ARTICLES_ALL.label));
  section.appendChild(head);

  const grid = node('div', 'bs-hp-arts__track');
  ARTICLES.forEach(function (art) {
    const card = link(art.href, 'bs-hp-art');
    const media = node('span', 'bs-hp-art__media');
    if (art.image) {
      const img = document.createElement('img');
      img.src = MEDIA + art.image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    } else {
      media.appendChild(icon('photo', 'bs-hp-art__ph'));
    }
    card.appendChild(media);
    card.appendChild(node('span', 'bs-hp-art__title', art.title));
    if (art.meta) card.appendChild(node('span', 'bs-hp-art__meta', art.meta));
    grid.appendChild(card);
  });
  section.appendChild(grid);
  return section;
}

// ---------------------------------------------------------------------------
// 7. O nás — přestavba nativního `.welcome`
// ---------------------------------------------------------------------------

function buildAbout(content) {
  const wrapper = content.querySelector('.welcome-wrapper');
  const welcome = wrapper && wrapper.querySelector('.welcome');
  if (!welcome) return null;

  wrapper.classList.add('bs-about');
  welcome.classList.add('bs-about__inner');

  const text = node('div', 'bs-about__text');
  welcome.insertBefore(text, welcome.firstChild);
  text.appendChild(node('span', 'bs-about__eyebrow', ABOUT.eyebrow));

  // Nativní nadpis shopu (`div.h1[data-testid=eshopHeader]`) přetextujeme na claim
  // z designu — zůstává jediným nadpisem sekce, žádný duplicitní uzel nevzniká.
  const title = welcome.querySelector('[data-testid="eshopHeader"], .h1');
  if (title) {
    title.classList.add('bs-about__title');
    title.textContent = ABOUT.title;
    text.appendChild(title);
  }

  // Tělo = nativní odstavce; fotku prodejny z nich vytáhneme do sloupce vpravo.
  const body = welcome.querySelector('div:not(.bs-about__text):not(.h1)');
  const media = node('div', 'bs-about__media');
  if (body) {
    body.classList.add('bs-about__body');
    // SK nese fotku v `p > span > img` (den D 25. 9.) → jakýkoli potomek odstavce
    const photo = body.querySelector('p img');
    const holder = photo ? photo.closest('p') : null;
    if (holder) {
      holder.classList.add('bs-about__photo');
      if (photo) photo.loading = 'lazy'; // sekce je hluboko pod ohybem (fáze 0 plánu rychlosti)
      media.appendChild(holder);
    }
    text.appendChild(body);
  }

  // shop bez prodejny (SK) nemá kam odkázat ani čím podepsat fotku
  if (ABOUT.cta.href) {
    const cta = link(ABOUT.cta.href, 'bs-btn bs-about__cta', ABOUT.cta.label);
    cta.appendChild(icon('arrow-right'));
    text.appendChild(cta);
  }

  if (!media.firstChild) media.appendChild(icon('photo', 'bs-about__ph'));
  if (ABOUT.badgeText) {
    const badge = node('div', 'bs-about__badge');
    badge.appendChild(icon('store', 'bs-about__badge-icon'));
    const badgeText = node('span', 'bs-about__badge-text');
    badgeText.appendChild(node('strong', null, ABOUT.badgeTitle));
    badgeText.appendChild(node('span', null, ABOUT.badgeText));
    badge.appendChild(badgeText);
    media.appendChild(badge);
  }
  welcome.appendChild(media);

  return wrapper;
}

// ---------------------------------------------------------------------------

export function initHomepage() {
  if (!document.body.classList.contains('type-index')) return;
  const content = document.getElementById('content');
  if (!content || content.dataset.bsHp) return;
  content.dataset.bsHp = '1';

  const banners = content.querySelector('.row.banners-row');
  const usp = content.querySelector('.benefitBanner');

  // 1. hero před nativní pás bannerů (ten skryje CSS pod html.bs-hp-ready)
  buildHero(content, banners || usp || content.firstChild);

  // 2. H1 blok + 3. rozcestník kategorií nad USP pás
  const intro = buildIntro(content);
  const cats = buildCats(content);
  const uspAnchor = usp || content.querySelector('.products-wrapper');
  if (uspAnchor) {
    if (intro) content.insertBefore(intro, uspAnchor);
    if (cats) content.insertBefore(cats, uspAnchor);
  }

  // 4. produktové řady rozdělené do barevných zón (handoff §Rytmus stránky):
  //    bílá „Nejoblíbenější" → červená SLEVOAKCE → šedá Novinky + bento + …
  // Řadu do zóny klíčujeme na text nadpisu z adminu, ne na pořadí.
  const rows = enhanceRows(content);
  const bento = buildBento();
  const sale = rows.find((r) => SALE_MATCH.test(r.label)) || null;
  const rest = rows.filter((r) => r !== sale);

  if (rest[0]) {
    buildRowHead(rest[0], { lead: true, sub: rowSub(rest[0].label) });
    rest[0].holder.classList.add('bs-prow--lead');
  }
  if (sale) buildSaleZone(content, sale);
  const grey = buildGreyZone(content, rest.slice(1), bento);

  // 5.–6. O nás, Rady a návody (hodnocení staví patička — reviews.js)
  const about = buildAbout(content);
  const articles = buildArticles();
  if (articles) {
    if (about) about.insertAdjacentElement('afterend', articles);
    else content.appendChild(articles);
  }

  // Homepage bez druhé produktové řady šedou zónu nedostane — bento pak jde
  // za první řadu, jinak před články (pořadí bloků řídí admin).
  if (!grey) {
    if (rest[0]) rest[0].holder.insertAdjacentElement('afterend', bento);
    else if (sale) sale.holder.closest('.bs-sale').insertAdjacentElement('afterend', bento);
    else content.insertBefore(bento, articles);
  }

  // Homepage stojí → teprve teď smí CSS skrýt nativní carousel bannerů.
  document.documentElement.classList.add('bs-hp-ready');

  // 7. sezónní obsah z indexu (F4) — až po load, nikdy neblokuje první vykreslení
  scheduleIndexEnhancements(rest[0] || null, cats);
}
